import React from 'react';
import { Text, useIsMobile } from '@amzn/storm-ui';
import styled from 'styled-components';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';

export const NoAccountsContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  padding: ${({ theme, isMobile }) =>
    !isMobile
      ? `${theme.spacing.xsmall.default} ${theme.spacing.base.default}`
      : `${theme.spacing.xsmall.mobile} ${theme.spacing.base.mobile}`};
  justify-content: center;
`;

export const NoAccountsMessage: React.VFC = () => {
  const bundle = useAccountDropdownBundle();
  const isMobile = useIsMobile();

  return (
    <NoAccountsContainer isMobile={isMobile ?? false}>
      <Text color="tertiary" size="xsmall">
        {bundle.getMessage('account-dropdown-no-accounts-found')}
      </Text>
    </NoAccountsContainer>
  );
};
